import { render, staticRenderFns } from "./approveNames.vue?vue&type=template&id=a4a7cc72&scoped=true&"
import script from "./approveNames.vue?vue&type=script&lang=js&"
export * from "./approveNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a7cc72",
  null
  
)

export default component.exports